import React from "react";
import cameraIcon2 from "../../assets/images/svg/cameraIcon2.svg";

const UploadProfileTooltip = ({ children, ariaLabel = "Upload Image" }) => {
  return (
    <div className="upload-image-tooltip-wrapper">
      <button
        type="button"
        className="lastChild camera"
        aria-describedby="tooltip-save"
        aria-label={ariaLabel}
      >
        <img className="img2" src={cameraIcon2} alt="" />
      </button>

      <div id="tooltip-save" role="tooltip" className={`tooltip2`}>
        {children}
      </div>
    </div>
  );
};

export default UploadProfileTooltip;
